import React from 'react';
import { ExternalLink } from 'lucide-react';
import styled from 'styled-components';
import { adsEnabled } from '../../utils/adsEnabled';

const Card = styled.a`
  display: block;
  border-radius: ${({ theme }) => theme.radiusSm};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.card};
  box-shadow: ${({ theme }) => theme.shadowCard};
  transition: box-shadow 0.2s;
  text-decoration: none;
  color: inherit;
  &:hover {
    box-shadow: ${({ theme }) => theme.shadowCardHover};
  }
`;

const Img = styled.img`
  width: 100%;
  height: 10rem;
  object-fit: cover;
  display: block;
`;

const Body = styled.div`
  padding: 1rem;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
`;

const SponsoredTag = styled.span`
  padding: 0.125rem 0.5rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  background: rgba(234, 179, 8, 0.12);
  color: ${({ theme }) => theme.colors.gold};
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

const Sponsor = styled.span`
  font-size: 0.625rem;
  color: ${({ theme }) => theme.colors.mutedForeground};
`;

const Title = styled.h4`
  margin: 0;
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.foreground};
`;

const Desc = styled.p`
  margin: 0.25rem 0 0 0;
  font-size: ${({ theme }) => theme.fontClamp.xs};
  color: ${({ theme }) => theme.colors.mutedForeground};
  line-height: 1.5;
`;

const Cta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  margin-top: 0.75rem;
  font-size: ${({ theme }) => theme.fontClamp.xs};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
`;

function AdSidebar({ ad }) {
  if (!adsEnabled()) return null;

  return (
    <Card href={ad.url} target="_blank" rel="noopener noreferrer sponsored">
      <Img src={ad.image} alt={ad.title} loading="lazy" />
      <Body>
        <Row>
          <SponsoredTag>Sponsored</SponsoredTag>
          <Sponsor>{ad.sponsor}</Sponsor>
        </Row>
        <Title>{ad.title}</Title>
        <Desc>{ad.description}</Desc>
        <Cta>
          {ad.cta} <ExternalLink size={10} />
        </Cta>
      </Body>
    </Card>
  );
}

export default AdSidebar;
